// removed by extract-text-webpack-plugin
module.exports = {"root":"PaymentPage__root___TRlRI","updateSubscription":"PaymentPage__updateSubscription___1ZhiQ","headerImage":"PaymentPage__headerImage___2-s-p"};